/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { React,useRef,useState,useContext,useEffect } from 'react'
import { Link, useLocation, useParams, useSearchParams} from 'react-router-dom'
import TopHeader from '../../../../../components/TopHeader'
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt'
import AnimatedModel from '../../../../../components/Animation/AnimatedModel'
import Loader from '../../../../../components/Loader'
import Toast from '../../../../../components/Toast'
import TextArea from '../../../../../components/TextArea'
import GlobalContext from '../../../../../components/Context/GloablContext'
import { useSelector } from 'react-redux'
import { useAddNotesMutation, useExportPatientNotesMutation } from '../../../../../features/patientSlice'
import CustomOverLay from '../../../../../components/CustomOverLay'
import Emptyscreen from '../../../../../components/EmptyScreen'
import { convertEpochToDateFormat } from '../../../../../CommonMethods/DateConversion'
import Throttle from '../../../../../CommonMethods/Throttle'
import HelpGuideModal from '../../../../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../../../../features/patientSlice'
import { BeatLoader } from 'react-spinners'
import { dataService } from '../../../../../services/data.services'

export default function ManageWellnessNotes() {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const [addNotes] = useAddNotesMutation()
    const [searchParams, setSearchParams] = useSearchParams({})
    const location=useLocation()
    const [confirmation, setConfirmation] = useState(false)
    const [confirmationState, setConfirmationState] = useState(false)
    const outsideClickRef = useRef();
    const [isAnyFieldFilled,setIsAnyFieldFilled]=useState(false)
    const [loading, setLoading] = useState(false)
    const [isAddnote, setIsAddNote] = useState(false)
    const [wellnessNotes, setWellnessNotes] = useState('')
    const [emptyField, setEmptyField] = useState(false)
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const { patientId } = useParams()
    const [exportLoading,setExportLoading]=useState(false)
    const [exportNotes]=useExportPatientNotesMutation()


    let queryObject = {
        id: patientId
    };
    if (searchParams) {
        queryObject.body = {
            ...searchParams
        };
    }

    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [count,setCount]=useState('')    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-patients-contact-history');
        } else {
            setQueryParamsadmin('type=admin-patient-contact-history');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
        
    

    function handleEditOnChangeInput(id, value) {
        // Set throttle delay to 100 milliseconds
        const throttleDelay = 100;
        // Throttle the function to limit the frequency of updates
        const throttledHandleEditOnChangeInput = Throttle((id, value) => {
            setEmptyField(false);
            setIsAnyFieldFilled(true);
            setWellnessNotes(value);
        }, throttleDelay);
        // Call the throttled function with the provided arguments
        throttledHandleEditOnChangeInput(id, value);
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (items.length > 0) {
            const initialCollapsedState = items.map((_, index) => index !== 0);
            setCollapsedNotes(initialCollapsedState);
        }
    }, [items]);


    const [collapsedNotes, setCollapsedNotes] = useState(items.map((_, index) => index !== 0));
    
    const handleCollapseToggle = (index) => {
        setCollapsedNotes(prev => {
            const newCollapsedNotes = [...prev];
            newCollapsedNotes[index] = !newCollapsedNotes[index];
            return newCollapsedNotes;
        });
    };

    const fetchData = async (pageNumber) => {
        const currentPage = pageNumber || page; // Fallback to state if not provided
    
        if (!hasMore && currentPage !== 1) return; // Prevent unnecessary calls
    
        setIsLoading(true);
        try {
            const res = await dataService.PostAPI(
                '',
                `patients/list-wellness-note?type=wellness-note&patient_id=${patientId}&page_number=${currentPage}&limit=15`
            );
    
            const newItems = res?.data?.data?.patientData || [];
            const totalCount = res?.data?.data?.totalCount || 0;
    
            setCount(totalCount);
            if (newItems.length === 0) setHasMore(false); // No more data
    
            // Append or replace items based on the page number
            setItems(prevItems => (currentPage === 1 ? newItems : [...prevItems, ...newItems]));
            setPage(currentPage + 1); // Increment page for next call
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    };
    
    

    const handleScroll = () => {
        const scrollArea = document.getElementById('device_scrollarea');
        const { scrollTop, clientHeight, scrollHeight } = scrollArea;
    
        if (scrollHeight - scrollTop - clientHeight <= 10 && !isLoading) {
            fetchData(); // Load more notes
        }
    };

    
    function handleSaveButton() {
        if (!wellnessNotes || wellnessNotes.wellness_Notes === "") {
            // Field is empty, handle accordingly (show error message, prevent action, etc.)
            setEmptyField(true);
            setToastErrorMessage("Please fill the mandatory field");
            return; // Prevent further execution
        }
        // Field is not empty, proceed with saving and applying
        setConfirmationState(true);
        setIsAddNote(false);
        setConfirmation(false);
        
    }

    const handleAppendNotes = async () => {
        setLoading(true);
        const body = {
            note_type: "wellness-note",
            description: wellnessNotes,
            patient_id: patientId,
        };
    
        try {
            const response = await addNotes(body);
            if (response.data) {
                setToastmessage(response.data.message);
                setConfirmationState(false);
                setLoading(false);
                setWellnessNotes(''); // Clear the input field
    
                // Reset state before fetching the first page
                setPage(1);
                setItems([]);
                setHasMore(true);
    
                // Fetch the first page explicitly
                fetchData(1);
            } else {
                throw new Error(response?.data?.message);
            }
        } catch (error) {
            setToastErrorMessage(error.message);
            setConfirmationState(false);
            setEmptyField(false);
            setLoading(false);
            setWellnessNotes('');
        }
    };

    useEffect(() => {
        const adjustTextareaHeight = () => {
            const textareas = document.querySelectorAll('.auto-height-textarea');
          
            textareas.forEach((textarea) => {
                textarea.style.height = 'auto';
                textarea.style.height = `${textarea.scrollHeight}px`;
            });
        };
        // Call the adjustTextareaHeight function after the initial render
        adjustTextareaHeight();
        // Attach the adjustTextareaHeight function to the resize event to handle dynamic content changes
        window.addEventListener('resize', adjustTextareaHeight);
        // Clean up the event listener to prevent memory leaks
        return () => {
            window.removeEventListener('resize', adjustTextareaHeight);
        };
    }, [items,collapsedNotes]);

    const user_type_labels = {
        "admin-user": "Admin",
        "super-admin": "Super Admin",
        "corporate-user": "Corporate",
        "organization-user":"Organization User",
        "provider":"Provider",
        "observer":"Observer",
        "monitor-user": "Monitor",
    }
    async function handleExport(type){
        let patientId=queryObject?.id
        let noteType=type
        setExportLoading(true)

        let payload ={patientId,dateformat,noteType}
        const exportRes=await exportNotes(payload)
        setExportLoading(false)
        window.open(exportRes?.data.presigned_url)
        
        if(exportRes?.error){
            setToastErrorMessage("Something went wrong")
        }
        else{
            setToastmessage(exportRes?.data?.message)   
        }   
    }

    
    return (
        <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
            <TopHeader title={"Manage Patients"}/>
            <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                <div className="px-6">
                    <div className='flex items-center mb-3.5'>
                        <Link to="/manage-patients">
                            <h1 className="text-sm font-normal text-[#52555D]">List of Patients</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        <Link to={`/manage-patients/${location.state?.user_id ? location.state.user_id : location.state?.[2]}`}>
                            <h1 className="text-sm font-normal text-[#52555D]">View Patient</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        <div className=''>
                            <h1 className="text-sm font-normal text-[#008586]">Contact History</h1>
                        </div>
                        {
                            userType !=='super-admin' &&
                                <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                    <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                </span> 
                        }
                    </div>
                    <Link to={`/manage-patients/${location.state?.user_id ? location.state.user_id : location?.state?.[2]}`}className=' items-center min-w-max flex mb-1.5'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Patient</span>
                    </Link>
                    <div className='2xl:px-[58px] px-10'>
                        <div className='flex items-center justify-between'>
                            <h2 className='text-xl font-semibold text-[#000000] text-center w-full'>
                                Wellness Notes
                            </h2> 
                            { count > 0 &&
                                <button id="icon-export" disabled={exportLoading }  onClick={() => handleExport("wellness-note")}  className="border border-[#972E4C] rounded-[15px] px-[15px] py-[13px] disabled:cursor-not-allowed ml-4">
                                    {exportLoading?
                                        <div className='flex justify-center items-center'>                       
                                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-5 w-5 spin-animation"></div>                                                        
                                        </div>
                                        :<img src="/images/download-red.svg" alt="download-icon" />}
                                </button>
                            }
                        </div>
                        <div className='mt-[18px] flex justify-between items-center'>
                            <button
                                onClick={() => { setConfirmation(true) }}
                                type='button'
                                id='append_note'
                                className="px-[15px] py-2.5 rounded-[15px] flex items-center hover:bg-[#E7EAF4] text-base font-normal text-[#000000]">
                                <img src="/images/add-plus-red.svg" alt="add icon" />
                                <span className='pl-2'>Append Note</span>
                            </button>
                            {count > 0 &&
                            <div className='flex justify-end'>
                                <div className='bg-white'>
                                    <button type='button' id='collapse_all' className='text-[16px] text-[#008586] leading-normal font-normal'>
                                        <span className='cursor-pointer' onClick={() => setCollapsedNotes(prevState => prevState.map(() => true))}>Collapse All</span>
                                    </button>
                                    <button type='button' id='expand_all' className='pl-[16px] text-[16px] text-[#008586]  leading-normal font-normal'>
                                        <span className='cursor-pointer' onClick={() => setCollapsedNotes(prevState => prevState.map(() => false))}>Expand All</span>
                                    </button>

                                </div>
                            </div>
                            }
                        </div>
                        <div id={"device_scrollarea"} className='h-[calc(100vh-317px)] overflow-auto scrollbar_grayw6 px-2.5 pb-2.5 mt-2 rounded-lg' onScroll={handleScroll}>
                            {items.length===0&&isLoading?            
                                <CustomOverLay Active text="Loading Wellness Notes..." classKey={`right-20 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-full h-[calc(100vh-342px)]`} /> :
                                <>  
                                    {items.map((note, index) => (
                                        <div key={index}>
                                            <div className='bg-[#E5F3F3] w-full items-center py-2 rounded-[4px] mt-[7px] flex px-4 cursor-pointer' onClick={() => handleCollapseToggle(index)}>
                                                <p className='text-[18px] text-[#000] font-normal leading-normal'>
                                                    {note?.first_name || ''} <span className='pl-1'>{note?.last_name || ''}</span> <span className='pl-1'>
                                                        ({user_type_labels[note.user_type] || note.user_type})
                                                    </span>
                                                </p>
                                                <p className='text-[14px] pl-[24px] text-[#52555D] font-normal leading-normal'>{convertEpochToDateFormat(note.created_at,dateformat)}</p>
                                                <img className={`ml-auto cursor-pointer rotate ${!collapsedNotes[index] ? "rotate-180" : 'rotate-0'}`} src="/images/collapse.svg" alt="collapse" />
                                            </div>
                                            {!collapsedNotes[index] && (
                        
                                                <textarea
                                                    readOnly
                                                    value={note.description}
                                                    className='text-[16px] py-2 text-[#000000] font-normal w-full outline-0 resize-none auto-height-textarea text-justify'
                                                />
                                            )}
                                        </div>
                                    ))}
                                </>}
                                    
                            {items.length>0&&isLoading&&<div className="flex justify-center my-3"><BeatLoader color='#972E4C'/></div>}
                            {items?.length===0&&!isLoading&& 
                            <div className='h-full flex justify-center items-center'> 
                                <Emptyscreen
                                    ViewNotes={true}
                                    PatientNotes={true}
                                    title={"Manage Patients"}
                                    FirstPTag={"No Wellness notes to view yet."}
                                />
                            </div>
                            }
                                
                        </div>
                    </div>
                </div>
            </div>
            {confirmation &&
            <AnimatedModel key="edit-model"
                Children={
                    <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{ display: "block" }}>
                        <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                            <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px] pt-[24px] pb-5 relative">
                                <div className="flex justify-between pb-[16px] ">
                                    <h1 className='text-2xl font-normal text-[#000]'>Wellness Note</h1>
                                    <img
                                        onClick={() => {
                                            setConfirmation(false);
                                            setEmptyField(false);
                                            setWellnessNotes('')

                                        }} src='/images/close_icon.svg' className='cursor-pointer' />
                                </div>
                                <div className='pl-4 2xl:pl-[20px]  border border-[#C5C9DA] rounded-[8px] pr-4 pb-5 pt-2 overflow-auto overflow-x-hidden scrollbar_grayw6 h-customh12'>
                                    <TextArea
                                        PatientNotes={true}
                                        label={''}
                                        dataTestid={'wellness-Notes'}
                                        htmlFor={'wellness_Notes'}
                                        id={'wellness_Notes'}
                                        value={wellnessNotes}
                                        placeholder={'Type note here...'}
                                        emptyField={''}
                                        handleOnChangeInput={handleEditOnChangeInput}
                                        handleOnCLickActivate={''}
                                        add={isAddnote}
                                        loadingActivation={false}
                                    />

                                </div>

                                <button
                                    loading={loading}
                                    disabled={wellnessNotes.trim() === "" || wellnessNotes === undefined}
                                    id={'update'}
                                    onClick={handleSaveButton}
                                    className={`px-4 py-2.5 text-lg mt-3 font-semibold text-[#fff] rounded-[16px] w-max ml-auto
                                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>Save & Apply</button>
                            </div>

                        </div>
                        {
                            toastErrorMessage !== '' && <Toast
                                message={toastErrorMessage}
                                type='error'
                                setToastmessage={setToastErrorMessage}
                                modal={true}

                            />
                        }
                    </div>

                }
            />

            }
            {confirmationState && (
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleAppendNotes}
                            handleClose={() =>{ setConfirmationState(false),setWellnessNotes('')}} 
                            tittle={'Append Wellness Note'}
                            message={'Are you sure you want to append note?'}
                            buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                            CancelButton={'No'}
                            disabled={loading}

                        />
                    }
                />
            )}
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }
        </div>
    )
}
